import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseCellComponent } from '../base-cell.component';
import { TableCellsService } from '../table-cells.service';

/**
 * Ячейка типа Файл 'file'
 */
@Component({
    selector: 'app-file-cell',
    template: '<span [innerHtml]="getHtml() | sanitizeHtml"></span>',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileCellComponent extends BaseCellComponent {
    private readonly tableCellsService = inject(TableCellsService);
    getHtml() {
        const value = this.row[this.alias];
        if (!value) {
            return '';
        }
        return this.tableCellsService.getFileCreate(value, this.column.id as string);
    }
}
